<div class="scopeFolderItem" [class.selectedFolder]="selectedFolder">
    <span class="scopeFolderItemLabel">{{folderName}}</span>
    <div class="scopeFolderItemCount">
        <span class="littleTextBold">{{folderCount}}</span>
    </div>
</div>